import { SPONSOR_TYPES_ACTIONS } from './SPONSOR_TYPES_ACTIONS'
import { withStaticSponsors } from '../../data/staticSponsors'

export function sponsorTypesReducer(state, action) {
  switch (action.type) {
    case SPONSOR_TYPES_ACTIONS.SET_SPONSOR_TYPES:
      return {
        ...state,
        types: withStaticSponsors(action.payload.types),
      }
    case SPONSOR_TYPES_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
